import { PureComponent, Component, useState } from 'react';
import { withTranslation } from 'react-i18next';
import { bindActionCreators } from 'redux';
import { connect, useDispatch, useSelector } from 'react-redux';
import { AvForm, AvField } from 'availity-reactstrap-validation';
import { Formik } from 'formik';

import {
  Grid,
  Segment,
  Modal,
  Button,
  Icon,
  Label,
  Form,
  Dropdown,
  Message,
} from 'semantic-ui-react';

import { DeptService } from '../../../../services';
import { assign, isEmpty, get } from '../../../../utils/lodash';

import {
  getOrganizationUsers,
  getOrganizationUsersList,
  createOrganizationUsers,
  updateOrgUserType,
  resetUserPassword,
  deleteOrganizationUser,
  getUserActivitiesCount,
  getDepartmentHierarchy,
  getDepartmentLabels,
  assignDepartmentToUser,
} from '../../../../store/actions';

import PasswordChange from '../../../../components/passwordChange';
import { EmptyContainer, CustomTable } from '../../../../components';

import {
  CustomInput,
  CustomPasswordInput,
  CustomDropdown,
} from '../../../../components/form';

import {
  addNewUserByOrgInitialValues,
  addNewUserByOrgValidationSchema,
  assignDepartmentValidationSchema,
  assignDepartmentValues,
} from '../../../../validations/addNewUserByOrgValidation';

import { stopPropagation } from '../../../../utils';
import { LIMIT } from '../../../../utils/constant';
import { authMsg } from '../../../../utils/auth';

import { WithdrawUserConfirmationModal } from './WithdrawUserConfirmationModal';

import '../organization.scss';

class UserTypeForm extends PureComponent {
  constructor(props) {
    super(props);
    this.state = {};
  }

  handleValidSubmit(event, values) {
    const { updateOrgUserType, toggle, user, resetPage } = this.props;
    let form = {
      role: {},
    };
    if (values.role === 'organisationAdmin') {
      form.role.organisationAdmin = true;
    } else if (values.role === 'user') {
      form.role.organisationAdmin = false;
    } else {
      return;
    }
    updateOrgUserType(user.id, form);
    this.form && this.form.reset();
    if (resetPage) resetPage();
    toggle();
  }

  render() {
    const { t, toggle, user } = this.props;
    const defaultValue = user;

    return (
      <AvForm
        model={defaultValue}
        ref={(c) => (this.form = c)}
        onValidSubmit={(event, values) => this.handleValidSubmit(event, values)}
        className="venue-form"
      >
        <AvField
          label={t('formulary.user_type')}
          className="org-inputs"
          name="role"
          type="select"
          validate={{
            required: {
              value: true,
              errorMessage: 'User type is required',
            },
          }}
        >
          <option value="" disabled defaultValue>
            {t('formulary.select_user_type')}
          </option>
          <option value="organisationAdmin">
            {t('role.organisation_admin')}
          </option>
          <option value="user">{t('role.user')}</option>
        </AvField>
        <div className="model-buttons">
          <Button
            className="Secondary-Button"
            type="button"
            onClick={() => toggle()}
          >
            {t('actions.cancel')}
          </Button>
          <Button
            content={t('actions.update')}
            type="submit"
            className="Primary-Button"
          />
        </div>
      </AvForm>
    );
  }
}

class PassChangeForm extends Component {
  handleValidSubmit(values) {
    const { user, toggle, resetUserPassword } = this.props;

    const form = assign(user, values);
    resetUserPassword(form);
    this.form && this.form.reset();
    toggle();
  }

  render() {
    const { toggle } = this.props;
    return (
      <PasswordChange
        toggle={() => toggle()}
        handleValidSubmit={(values) => this.handleValidSubmit(values)}
      />
    );
  }
}

const ManageUserFilter = ({ organization, ...props }) => {
  const { t } = props;
  const dispatch = useDispatch();

  const { deptHierarchyFlattened, deptLabels } = organization;

  const onDepartmentChange = (value, setFieldValue) => {
    const currentPage = 1;
    dispatch(
      getOrganizationUsersList(
        currentPage,
        LIMIT,
        value === 'all' ? null : value
      )
    );
  };

  const deptNameOptions = [
    { key: 'None', text: `(${t('common.all')})`, value: 'all' },
    ...deptHierarchyFlattened.map((item) => ({
      text: item.name,
      value: item.id,
      className: `level-${item.level}`,
    })),
  ];

  return (
    <Formik initialValues={{ departmentId: 'all' }}>
      {({ values, setFieldValue }) => (
        <Form>
          <div className="manage-user-drop">
            {!isEmpty(deptHierarchyFlattened) && (
              <div className="manage-user-container">
                <label>
                  {DeptService.deptLabelsAsConcatenatedLabel(deptLabels)}
                </label>
                <CustomDropdown
                  className="manage-user-type custom-dept-dropdown"
                  name="departmentId"
                  id="departmentId"
                  selection
                  search
                  options={deptNameOptions}
                  getValue={(value) => onDepartmentChange(value, setFieldValue)}
                />
              </div>
            )}
          </div>
        </Form>
      )}
    </Formik>
  );
};

class UserDelete extends PureComponent {
  constructor(props) {
    super(props);
    this.state = {
      modal: false,
    };
  }

  async toggle() {
    const { modal } = this.state;
    const { user, getUserActivitiesCount } = this.props;
    this.setState((prevState) => ({
      modal: !prevState.modal,
    }));
    !modal && (await getUserActivitiesCount(user.id));
  }

  async handleDeleteOrgUser() {
    const {
      t,
      deleteOrganizationUser,
      user,
      resetPage,
      withdrawUserConfirmationModalHandler,
      userActivities,
    } = this.props;

    const ownedActivities =
      userActivities.inActiveOwned +
      userActivities.inDevelopmentOwned +
      userActivities.completedOwned;

    if (ownedActivities > 0) {
      authMsg(
        'error',
        t(
          'organisation.user_management.reassign_activity.user_has_owned_activities',
          { ownedActivities }
        )
      );
      this.toggle();
    } else if (
      userActivities.inDevelopmentInvited > 0 ||
      userActivities.inActiveInvited > 0
    ) {
      this.toggle();
      withdrawUserConfirmationModalHandler(true, user);
    } else {
      deleteOrganizationUser(user.id);
      if (resetPage) resetPage();
      this.toggle();
    }
  }

  render() {
    const { modal } = this.state;
    const { t, user } = this.props;

    return (
      <Modal
        open={modal}
        onOpen={() => this.toggle()}
        onClick={(e) => stopPropagation(e)}
        onFocus={(e) => stopPropagation(e)}
        closeIcon={
          <Icon
            onClick={() => this.toggle()}
            name="close"
            className="closeicon"
          />
        }
        size="mini"
        trigger={this.props.trigger}
        className="delete-user"
      >
        <Modal.Header>
          {t('organisation.user_management.delete_user')} - {user.name}
        </Modal.Header>
        <Modal.Content>
          <p>{t('organisation.user_management.delete_user_confirmation')}</p>
        </Modal.Content>
        <Modal.Actions>
          <Button onClick={() => this.toggle()} className="Secondary-Button">
            {t('actions.no')}
          </Button>
          <Button
            onClick={() => this.handleDeleteOrgUser()}
            className="Primary-Button"
            content={t('actions.yes')}
          />
        </Modal.Actions>
      </Modal>
    );
  }
}

function UserPassChangeMenuItem(props) {
  const { t } = props;
  const [open, setOpen] = useState(false);

  return (
    <>
      <Dropdown.Item onClick={() => setOpen(true)}>
        <label className="black-text">{t('actions.reset_password')}</label>
      </Dropdown.Item>
      <UserPassChange {...props} open={open} onClose={() => setOpen(false)} />
    </>
  );
}

class UserPassChange extends PureComponent {
  render() {
    const { t, user, open, onClose } = this.props;

    return (
      <Modal
        size="tiny"
        open={open}
        onClick={(e) => stopPropagation(e)}
        onFocus={(e) => stopPropagation(e)}
        closeIcon={
          <Icon onClick={onClose} name="close" className="closeicon" />
        }
      >
        <Modal.Header>
          {t('actions.reset_password')} - {user.name}
        </Modal.Header>
        <Modal.Content>
          <PassChangeForm toggle={onClose} {...this.props} />
        </Modal.Content>
      </Modal>
    );
  }
}

function UserTypeChangeMenuItem(props) {
  const { t } = props;
  const [open, setOpen] = useState(false);

  return (
    <>
      <Dropdown.Item onClick={() => setOpen(true)}>
        <label className="black-text">
          {t('organisation.user_management.change_user_type_trigger')}
        </label>
      </Dropdown.Item>
      <UserTypeChange {...props} open={open} onClose={() => setOpen(false)} />
    </>
  );
}

class UserTypeChange extends PureComponent {
  render() {
    const { t, user, open, onClose } = this.props;
    return (
      <Modal
        size="small"
        open={open}
        onClick={(e) => stopPropagation(e)}
        onFocus={(e) => stopPropagation(e)}
        closeIcon={
          <Icon onClick={onClose} name="close" className="closeicon" />
        }
      >
        <Modal.Header>
          {t('organisation.user_management.change_user_type_trigger')} -{' '}
          {user.name}
        </Modal.Header>
        <Modal.Content>
          <UserTypeForm toggle={onClose} {...this.props} />
        </Modal.Content>
      </Modal>
    );
  }
}

class UserCreateForm extends PureComponent {
  constructor(props) {
    super(props);
    this.state = {
      pass: false,
      isShownPass: false,
      departmentId: null,
    };
  }

  handleValidSubmit(values) {
    try {
      const { createOrganizationUsers, toggle, resetPage } = this.props;
      if (!values.departmentId) {
        values.departmentId = null;
      }
      if (values.confirmPassword) {
        delete values.confirmPassword;
      }
      createOrganizationUsers(values);
      this.form?.reset();
      if (resetPage) {
        resetPage();
      }
      toggle();
    } catch (error) {
      console.error('UserCreateForm -> handleValidSubmit -> error :', error);
    }
  }

  validate = (value, ctx, input, cb) => {
    const { t, auth } = this.props;
    const domain = auth.user?.organisation?.domain || '-';
    let getDomain = value.split('@');

    return getDomain[1] === domain
      ? true
      : t('formulary.validation.email_does_not_match_org_email_domain');
  };

  getDeptNameOptions() {
    const { t } = this.props;
    const { deptHierarchyFlattened } = this.props.organization;

    return [
      { key: 'None', text: `(${t('common.all')})`, value: 'all' },
      ...deptHierarchyFlattened.map((item) => ({
        text: item.name,
        value: item.id,
        className: `level-${item.level}`,
      })),
    ];
  }

  async onChange(value) {
    this.setState({
      departmentId: value,
    });
  }

  render() {
    const { t } = this.props;
    const { deptLabels } = this.props.organization;
    const { isShownPass, departmentId } = this.state;

    const { auth, toggle } = this.props;
    let settings = get(auth, 'user.organisation.settings', [null]);
    [settings] = settings;

    const isDepartmentOn = settings
      ? get(settings, 'department', false)
      : false;

    return (
      <Formik
        initialValues={addNewUserByOrgInitialValues(isDepartmentOn)}
        onSubmit={(values) => {
          this.handleValidSubmit(values);
        }}
        validationSchema={addNewUserByOrgValidationSchema(t, isDepartmentOn)}
      >
        {({ handleSubmit, isSubmitting, setFieldValue, errors }) => (
          <Form onSubmit={handleSubmit}>
            <div className="formik-custom-field-margin-top-zero">
              <CustomInput
                name="firstName"
                id="firstName"
                labelText={t('formulary.first_name')}
                placeholder={t('formulary.placeholder.enter_first_name')}
              />
            </div>
            <CustomInput
              name="surname"
              id="surname"
              labelText={t('formulary.surname')}
              placeholder={t('formulary.placeholder.enter_surname')}
            />

            <CustomInput
              name="email"
              id="email"
              labelText={t('formulary.email')}
              placeholder={t('formulary.placeholder.enter_email')}
            />

            {isDepartmentOn && (
              <>
                <CustomDropdown
                  name="departmentId"
                  id="departmentId"
                  className="custom-dept-dropdown"
                  labelText={deptLabels?.[0]?.label || ''}
                  options={this.getDeptNameOptions()}
                  getValue={(e) => this.onChange(e)}
                  placeholder={`${t('formulary.select')} ${deptLabels?.[0]?.label || ''}`}
                  selection
                />
              </>
            )}

            <CustomPasswordInput
              id="password"
              name="password"
              labelText={t('formulary.new_password')}
              placeholder={t('formulary.new_password')}
            />

            <CustomInput
              id="confirmPassword"
              name="confirmPassword"
              placeholder={t('formulary.confirm_password')}
              labelText={t('formulary.confirm_password')}
              type={isShownPass ? 'text' : 'password'}
              icon={
                <Icon
                  name={isShownPass ? 'eye' : 'eye slash'}
                  onClick={() => {
                    this.setState({ isShownPass: !isShownPass });
                  }}
                  link
                />
              }
            />

            <div className="model-buttons">
              <Button
                className="modal-cancel"
                type="button"
                onClick={() => toggle()}
              >
                {t('actions.cancel')}
              </Button>
              <Button
                content={t('actions.create')}
                type="submit"
                className="modal-proceed"
              />
            </div>
          </Form>
        )}
      </Formik>
    );
  }
}

class UserCreate extends PureComponent {
  render() {
    const { t, open, onClose } = this.props;
    return (
      <Modal
        size="small"
        open={open}
        closeIcon={
          <Icon onClick={onClose} name="close" className="closeicon" />
        }
        className="add-new-user"
      >
        <Modal.Header>{t('specific_actions.add_user')}</Modal.Header>
        <Modal.Content>
          <UserCreateForm toggle={onClose} {...this.props} />
        </Modal.Content>
      </Modal>
    );
  }
}

function EditUserDeptMenuItem(props) {
  const { t } = props;
  const { deptLabels } = props.organization;
  const [open, setOpen] = useState(false);

  return (
    <>
      <Dropdown.Item onClick={() => setOpen(true)}>
        <label className="black-text">
          {t('actions.edit')} {deptLabels?.[0]?.label || ''}
        </label>
      </Dropdown.Item>
      <EditUserDeptModal
        {...props}
        open={open}
        onClose={() => setOpen(false)}
      />
    </>
  );
}

class EditUserDeptModal extends PureComponent {
  constructor(props) {
    super(props);
    this.state = {
      isDeleteDepartment: false,
      departmentId: null,
    };
  }

  async componentDidMount() {
    const { user } = this.props;

    if (!isEmpty(user.department)) {
      this.setState({
        departmentId: user.department.id,
      });
    }
  }

  async componentDidUpdate(prevProps, prevState) {
    const { user } = this.props;

    // if (user?.department && user !== prevProps.user) {
    if (user?.department) {
      this.setState({
        departmentId: user.department.id,
      });
    }
  }

  async handleValidSubmit(values, setSubmitting) {
    try {
      const { onClose, assignDepartmentToUser, user } = this.props;
      await assignDepartmentToUser(user.id, values);
      onClose();
      setSubmitting(false);
    } catch (error) {
      setSubmitting(false);
    }
  }

  getDeptDropdownOptions() {
    const { t } = this.props;
    const { deptHierarchyFlattened } = this.props.organization;

    return [
      { key: 'None', text: `(${t('common.none')})`, value: 0 },
      ...deptHierarchyFlattened.map((item) => ({
        text: item.name,
        value: item.id,
        className: `level-${item.level}`,
      })),
    ];
  }

  async onChange(value) {
    const { user } = this.props;
    this.setState({
      departmentId: value,
      isDeleteDepartment: !value && user.departmentId > 0,
    });
  }

  render() {
    const { t, open, onClose, user } = this.props;
    const { deptLabels } = this.props.organization;
    const { isDeleteDepartment } = this.state;

    return (
      <Modal
        size="small"
        open={open}
        onClick={(e) => stopPropagation(e)}
        onFocus={(e) => stopPropagation(e)}
        closeIcon={
          <Icon onClick={onClose} name="close" className="closeicon" />
        }
        className="add-new-user"
      >
        <Modal.Header>
          {t('actions.edit')} {deptLabels?.[0]?.label || ''}
        </Modal.Header>
        <Modal.Content>
          <Formik
            initialValues={assignDepartmentValues(user.department)}
            onSubmit={(values, { setSubmitting }) => {
              this.handleValidSubmit(values, setSubmitting);
            }}
            validationSchema={assignDepartmentValidationSchema}
          >
            {({
              handleSubmit,
              isSubmitting,
              setFieldValue,
              errors,
              values,
            }) => {
              return (
                <Form onSubmit={handleSubmit}>
                  <CustomDropdown
                    name="departmentId"
                    id="departmentId"
                    className="custom-dept-dropdown"
                    labelText={DeptService.deptLabelsAsConcatenatedLabel(
                      deptLabels
                    )}
                    options={this.getDeptDropdownOptions()}
                    getValue={(e) => this.onChange(e)}
                    placeholder={`${t('formulary.select')} ${deptLabels?.[0]?.label}`}
                    selection
                    search
                  />
                  {isDeleteDepartment && (
                    <div className="msg-report">
                      <Message
                        color="blue"
                        icon="exclamation circle"
                        content={t(
                          'organisation.user_management.department_removed_from_user'
                        )}
                      />
                    </div>
                  )}

                  <div className="model-buttons">
                    <Button
                      className="modal-cancel"
                      type="button"
                      onClick={() => onClose()}
                    >
                      {t('actions.cancel')}
                    </Button>

                    <Button
                      content={t('actions.save')}
                      type="submit"
                      className="modal-proceed"
                      loading={isSubmitting}
                      disabled={isSubmitting}
                    />
                  </div>
                </Form>
              );
            }}
          </Formik>
        </Modal.Content>
      </Modal>
    );
  }
}

class OrganizationUserManagement extends PureComponent {
  constructor(props) {
    super(props);
    this.state = {
      currentPage: 1,
      withdrawUserConfirmationModal: false,
      selectedUser: {},
      addUserOpen: false,
    };
  }

  columns = ((t) => [
    {
      title: t('formulary.user_name'),
      render: (data) => {
        const { auth } = this.props;
        return (
          <div className="org-users-container">
            <span className="org-users-cdn-container">
              <label className="org-users-mainText">
                {data.name}
                {auth.isSuperAdmin && (
                  <span className="user-id">#{data.id}</span>
                )}
              </label>
              {String(data.email).includes('cdn-admin@') ? (
                <Label color="orange" horizontal className="cdn-admin">
                  {t('organisation.user_management.cdn_admin').toLowerCase()}
                </Label>
              ) : null}
            </span>
            <label className="org-users-text">
              {this.renderUserType(data.role)}
            </label>
          </div>
        );
      },
      width: 4,
    },

    {
      title: t('formulary.email'),
      render: (data) => {
        return <label className="org-users-text">{data.email}</label>;
      },
      width: 4,
    },
    {
      title: t('formulary.phone'),
      render: (data) => {
        return data.phone ? (
          <label className="org-users-text">{data.phone}</label>
        ) : null;
      },
      width: 3,
    },
    {
      title: '',
      render: (data) => {
        const { auth } = this.props;
        return (
          <div className="invited">
            {data.role !== 'admin' && data.id !== auth.user.id ? (
              <Dropdown
                icon="ellipsis vertical"
                direction="left"
                inline
                selectOnBlur={false}
              >
                <Dropdown.Menu>
                  {/* TAK-2074: the menu items (which open their dialogs),
                      as in withDepartmentColumns — the bare dialogs drew
                      nothing, leaving only Remove */}
                  <UserTypeChangeMenuItem
                    user={data}
                    {...this.props}
                    resetPage={() => this.resetPage()}
                  />
                  <UserPassChangeMenuItem
                    user={data}
                    {...this.props}
                    resetPage={() => this.resetPage()}
                  />
                  <UserDelete
                    user={data}
                    {...this.props}
                    resetPage={() => this.resetPage()}
                    withdrawUserConfirmationModalHandler={(status, user) =>
                      this.withdrawUserConfirmationModalHandler(status, user)
                    }
                    trigger={
                      <Dropdown.Item
                        text={t('actions.remove')}
                        className="dropdown-customItem"
                      >
                        <div className="remove-activity">
                          <span>{t('actions.remove')}</span>
                        </div>
                      </Dropdown.Item>
                    }
                  />
                </Dropdown.Menu>
              </Dropdown>
            ) : (
              <div></div>
            )}
          </div>

          // <div className="org-users-actions">
          //   {data.role !== 'admin' && data.id !== auth.user.id ? (
          //     <Fragment>

          //     </Fragment>
          //   ) : (
          //     ''
          //   )}
          // </div>
        );
      },
      width: 1,
    },
  ])(this.props.t);

  withDepartmentColumns = ((t) => [
    {
      title: t('formulary.user_name'),
      render: (data) => {
        const { auth } = this.props;
        return (
          <div className="org-users-container">
            <span className="org-users-cdn-container">
              <label className="org-users-mainText">
                {data.name}
                {auth.isSuperAdmin && (
                  <span className="user-id">#{data.id}</span>
                )}
              </label>
              {String(data.email).includes('cdn-admin@') ? (
                <Label color="orange" horizontal className="cdn-admin">
                  {t('organisation.user_management.cdn_admin').toLowerCase()}
                </Label>
              ) : null}
            </span>
            <label className="org-users-text">
              {this.renderUserType(data.role)}
            </label>
          </div>
        );
      },
      width: 4,
    },
    {
      title: t('formulary.department'),
      render: (data) => {
        const { deptHierarchyFlattened } = this.props.organization;
        return (
          <span className="org-users-dept-names">
            {data.department?.ancestorIds && (
              <span className="dept-ancestors">
                {DeptService.deptsAsConcatenatedLabel(
                  deptHierarchyFlattened,
                  data.department.ancestorIds
                )}
              </span>
            )}
            <span className="dept-name">{data.department?.name || '-'}</span>
          </span>
        );
      },
      width: 2,
    },
    {
      title: t('formulary.email'),
      render: (data) => {
        return <label className="org-users-text">{data.email}</label>;
      },
      width: 4,
    },
    {
      title: t('formulary.phone'),
      render: (data) => {
        return data.phone ? (
          <label className="org-users-text">{data.phone}</label>
        ) : null;
      },
      width: 3,
    },
    {
      title: '',
      render: (data) => {
        const { auth } = this.props;
        return (
          <div className="invited">
            {data.role !== 'admin' && data.id !== auth.user.id ? (
              <Dropdown
                icon="ellipsis vertical"
                direction="left"
                inline
                selectOnBlur={false}
              >
                <Dropdown.Menu>
                  <EditUserDeptMenuItem user={data} {...this.props} />

                  <UserTypeChangeMenuItem
                    user={data}
                    {...this.props}
                    resetPage={() => this.resetPage()}
                  />

                  <UserPassChangeMenuItem
                    user={data}
                    {...this.props}
                    resetPage={() => this.resetPage()}
                  />

                  <Dropdown.Item>
                    <UserDelete
                      user={data}
                      {...this.props}
                      resetPage={() => this.resetPage()}
                      withdrawUserConfirmationModalHandler={(status, user) =>
                        this.withdrawUserConfirmationModalHandler(status, user)
                      }
                      trigger={
                        <Dropdown.Item
                          text={t('actions.remove')}
                          className="dropdown-customItem"
                        >
                          <div className="remove-activity">
                            <span>{t('actions.remove')}</span>
                          </div>
                        </Dropdown.Item>
                      }
                    />
                  </Dropdown.Item>
                </Dropdown.Menu>
              </Dropdown>
            ) : (
              <div></div>
            )}
          </div>

          // <div className="org-users-actions">
          //   {data.role !== 'admin' && data.id !== auth.user.id ? (
          //     <Fragment>

          //     </Fragment>
          //   ) : (
          //     ''
          //   )}
          // </div>
        );
      },
      width: 1,
    },
  ])(this.props.t);

  withdrawUserConfirmationModalHandler(status, selectedUser) {
    this.setState({ withdrawUserConfirmationModal: status, selectedUser });
  }

  resetPage() {
    this.setState({
      currentPage: 1,
    });
  }

  renderUserType(role) {
    const { t } = this.props;

    switch (role) {
      case 'admin':
        return t('role.super_admin');
      case 'organisationAdmin':
        return t('role.organisation_admin');
      case 'user':
        return t('role.user');
      case 'guest':
        return t('role.guest');
      default:
        break;
    }
  }

  async componentDidMount() {
    const { currentPage } = this.state;
    const {
      getOrganizationUsersList,
      getOrganizationUsers,
      auth,
      getDepartmentHierarchy,
      getDepartmentLabels,
    } = this.props;

    if (auth?.user?.organisation) {
      await Promise.all([
        getOrganizationUsers(),
        getOrganizationUsersList(currentPage),
        getDepartmentHierarchy(),
        getDepartmentLabels(),
      ]);
    }
  }

  pageChange(page) {
    const { auth, getOrganizationUsersList } = this.props;
    this.setState(
      {
        currentPage: page,
      },
      () => {
        if (!isEmpty(auth.user) && auth.user.organisation) {
          getOrganizationUsersList(page);
        }
      }
    );
  }

  render() {
    const { t, auth } = this.props;
    const { currentPage } = this.state;
    const { loading, orgUsersLoading, orgUsersList } = this.props.organization;
    const [orgDepartment] = get(auth, 'user.organisation.settings', [
      { department: false },
    ]);

    let settings = get(auth, 'user.organisation.settings', [null]);
    [settings] = settings;

    const isDepartmentOn = settings
      ? get(settings, 'department', false)
      : false;

    return (
      <Segment
        className="content-segment org-users"
        loading={loading || orgUsersLoading}
      >
        <Grid>
          <Grid.Row>
            <Grid.Column mobile={16} tablet={16} computer={16}>
              <div className="manage-user-drop">
                {orgDepartment.department && (
                  <ManageUserFilter {...this.props} />
                )}

                <div className="manage-user-addUser">
                  <div className="add-user">
                    <Button
                      className="Primary-Button"
                      onClick={() => this.setState({ addUserOpen: true })}
                    >
                      <Icon name="plus" />
                      {t('specific_actions.add_user')}
                    </Button>
                  </div>
                  <UserCreate
                    {...this.props}
                    resetPage={() => this.resetPage()}
                    open={this.state.addUserOpen}
                    onClose={() => this.setState({ addUserOpen: false })}
                  />
                </div>
              </div>
            </Grid.Column>
          </Grid.Row>
        </Grid>

        {orgUsersList.docs && orgUsersList.docs.length ? (
          <div className="org-table-container">
            <CustomTable
              header
              columns={
                isDepartmentOn ? this.withDepartmentColumns : this.columns
              }
              data={orgUsersList.docs}
              customClass="org-users-table"
              pagination
              handlePaginationChange={(page) => this.pageChange(page)}
              page={currentPage}
              noOfPages={orgUsersList.pages}
              keyExtractor={(item, index) => item.id}
            />
          </div>
        ) : (
          <EmptyContainer msg={`${t('formulary.no_users')}…`} />
        )}

        <div>
          <WithdrawUserConfirmationModal
            user={this.state.selectedUser}
            userActivities={this.props.userActivities}
            // {...this.props}
            resetPage={() => this.resetPage()}
            modal={this.state.withdrawUserConfirmationModal}
            handleModal={(status) =>
              this.withdrawUserConfirmationModalHandler(status)
            }
          />
        </div>
      </Segment>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    auth: state.authentication,
    organization: state.organization,
    userActivities: state.organization.userActivities,
  };
};

const mapDispatchToProps = (dispatch) => {
  return bindActionCreators(
    {
      getOrganizationUsers,
      getOrganizationUsersList,
      createOrganizationUsers,
      updateOrgUserType,
      resetUserPassword,
      deleteOrganizationUser,
      getUserActivitiesCount,
      getDepartmentHierarchy,
      getDepartmentLabels,
      assignDepartmentToUser,
    },
    dispatch
  );
};

OrganizationUserManagement = connect(
  mapStateToProps,
  mapDispatchToProps
)(withTranslation()(OrganizationUserManagement));

export { OrganizationUserManagement };
